<template>
  <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w">
    <p class="w100 font-18 tx-c">
      <span class="fl blue font-14 cu-p" @click="backPage">返回详情</span>
      在线咨询 - {{ title }}
    </p>
    
  </div>
</template>

<script>
export default {
  name: "Consult",
  components: {},
  props: [],
  data() {
    return {

      title: ""
    };
  },
  computed: {},
  mounted() {
    this.title = this.$route.params.title;
  },
  methods: {
    backPage() {
      this.$router.push({
        name: "server_info",
        query: {
          id: this.$route.params.id
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
